import { isNil } from 'lodash';

import { USER_MODE_MAP_BY_TYPE } from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/constants';

/**
 * @param {String} currentUserMode Retrieved current user mode from BE
 * @param {String} comparedType Compared user type that we defined on useUserRedux and user/reducers
 * @param {String | Array<String>} type User type array from retrieved user state
 * @returns True or False depending after comparison
 */
const compareUserMode = (currentUserMode = null, comparedType, type = []) => {
  if (!isNil(currentUserMode)) {
    return USER_MODE_MAP_BY_TYPE[comparedType].includes(currentUserMode);
  }
  return type.includes(comparedType);
};

export default compareUserMode;
